"use strict";

var partnersContainer = document.querySelector("#partners-fade");
if (!partnersContainer) {
  throw new Error("Partners container not found");
}
var partnerSlides = partnersContainer.querySelectorAll("& > div");
console.log(partnerSlides);
var delay = 3000;
function fadeSlides() {
  partnerSlides.forEach(function (slide, i) {
    setTimeout(function () {
      partnerSlides.forEach(function (s, j) {
        if (i === j) {
          s.classList.remove("opacity-0");
        } else {
          s.classList.add("opacity-0");
        }
      });
      setTimeout(function () {
        partnerSlides[i].classList.add("opacity-0");
        partnerSlides[(i + 1) % partnerSlides.length].classList.remove("opacity-0");
      }, delay);
    }, i * delay);
  });
}
fadeSlides();
setInterval(fadeSlides, partnerSlides.length * delay);
//# sourceMappingURL=partnersFade.js.map